import { columnDef_header_Z721C83C5, columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, ColumnHelper_accessor_36841BC5, columnDef_footer_Z5FD1F5D2, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, ColumnHelper_accessor_10721996, ColumnHelper_createColumnHelper_Z2906D979 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton as singleton_2, exists, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { FSharpRef, Record, Union } from "../fable_modules/fable-library.3.7.1/Types.js";
import { bool_type, lambda_type, unit_type, tuple_type, class_type, array_type, record_type, union_type, int32_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { MakeData_make, Types_Person$reflection } from "../MakeData.fs.js";
import { sleep, startImmediate } from "../fable_modules/fable-library.3.7.1/Async.js";
import { singleton } from "../fable_modules/fable-library.3.7.1/AsyncBuilder.js";
import { append, map, toArray, singleton as singleton_1, collect, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { tryGetValue } from "../fable_modules/fable-library.3.7.1/MapUtil.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.1/Range.js";
import { head } from "../fable_modules/fable-library.3.7.1/Array.js";
import { Table_getFooterGroups_Z4395D14A, Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { round, int32ToString, createObj, partialApply, uncurry } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Cmd_none, Cmd_ofSub } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { Table_getPageCount_Z4395D14A, Table_hasNextPage_Z4395D14A, Table_hasPreviousPage_Z4395D14A, Table_setPageCount } from "../../Feliz.TanStack.Table/Pagination.fs.js";
import { Table_getState_Z4395D14A, Table_setPaginationState, Table_setData } from "../../Feliz.TanStack.Table/TableState.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { FSharpMap__get_Item, ofList } from "../fable_modules/fable-library.3.7.1/Map.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export const columnDef = ColumnHelper_createColumnHelper_Z2906D979(ofArray([ColumnHelper_accessor_10721996("firstname", ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_footer_Z5FD1F5D2((info_1) => info_1.column.id)])), ColumnHelper_accessor_36841BC5((p) => p.Lastname, ofArray([columnDef_id_Z721C83C5("lastName"), columnDef_cell_Z1DDB00E5((info_2) => createElement("i", {
    children: info_2.getValue(),
})), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((info_3) => info_3.column.id)])), ColumnHelper_accessor_10721996("Age", ofArray([columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((info_4) => info_4.column.id)])), ColumnHelper_accessor_10721996("Visits", ofArray([columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((info_5) => info_5.column.id)])), ColumnHelper_accessor_10721996("Status", ofArray([columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((info_6) => info_6.column.id)])), ColumnHelper_accessor_10721996("Progress", ofArray([columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((info_7) => info_7.column.id)]))]));

export const totalItems = 1000;

export class PaginateChange extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["First", "Previous", "Next", "Last", "Index"];
    }
}

export function PaginateChange$reflection() {
    return union_type("Examples.PaginationControlled.PaginateChange", [], PaginateChange, () => [[], [], [], [], [["Item", int32_type]]]);
}

export class PageState extends Record {
    constructor(PageIndex, PageSize) {
        super();
        this.PageIndex = (PageIndex | 0);
        this.PageSize = (PageSize | 0);
    }
}

export function PageState$reflection() {
    return record_type("Examples.PaginationControlled.PageState", [], PageState, () => [["PageIndex", int32_type], ["PageSize", int32_type]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Paginate", "PageSizeChange", "FetchedData"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.PaginationControlled.Msg", [], Msg, () => [[["Item", PaginateChange$reflection()]], [["Item", int32_type]], [["Item", array_type(Types_Person$reflection())]]]);
}

export class State extends Record {
    constructor(Table, PageState, QueryFn, IsLoading) {
        super();
        this.Table = Table;
        this.PageState = PageState;
        this.QueryFn = QueryFn;
        this.IsLoading = IsLoading;
    }
}

export function State$reflection() {
    return record_type("Examples.PaginationControlled.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Types_Person$reflection()])], ["PageState", PageState$reflection()], ["QueryFn", lambda_type(tuple_type(int32_type, int32_type), lambda_type(lambda_type(Msg$reflection(), unit_type), unit_type))], ["IsLoading", bool_type]]);
}

export function query() {
    const cache = new Map([]);
    return (tupledArg) => {
        const count = tupledArg[1] | 0;
        return (dispatch) => {
            startImmediate(singleton.Delay(() => {
                let cachedData;
                const pageOffset = (tupledArg[0] * count) | 0;
                cachedData = toList(delay(() => collect((i) => {
                    let matchValue;
                    let outArg = null;
                    matchValue = [tryGetValue(cache, i, new FSharpRef(() => outArg, (v) => {
                        outArg = v;
                    })), outArg];
                    return matchValue[0] ? singleton_1([i, matchValue[1]]) : singleton_1([i, void 0]);
                }, rangeDouble(pageOffset, 1, pageOffset + count))));
                return singleton.Combine(exists((tupledArg_1) => (tupledArg_1[1] == null), cachedData) ? singleton.Bind(sleep(500), () => singleton.Return()) : singleton.Zero(), singleton.Delay(() => {
                    dispatch(new Msg(2, toArray(delay(() => collect((data) => {
                        if (data[1] == null) {
                            const person = head(MakeData_make(1));
                            cache.set(data[0], person);
                            return singleton_1(person);
                        }
                        else {
                            return singleton_1(data[1]);
                        }
                    }, cachedData)))));
                    return singleton.Zero();
                }));
            }));
        };
    };
}

export function createPaginationState(pageIndex, pageSize) {
    return {
        pageIndex: pageIndex,
        pageSize: pageSize,
    };
}

export function init() {
    const defaultPageSize = 10;
    const query_1 = query();
    return [new State(Table_init_Z5C3B000E(ofArray([["data", []], tableProps_columns_Z2906D979(columnDef), ["manualPagination", true], ["pageCount", ~(~(totalItems / defaultPageSize))]])), new PageState(0, 10), uncurry(2, query_1), true), Cmd_ofSub(query_1([0, defaultPageSize]))];
}

export function update(msg, state) {
    let i;
    switch (msg.tag) {
        case 1: {
            const size = msg.fields[0] | 0;
            return [new State(Table_setPageCount(~(~(totalItems / size)), Table_setData([], Table_setPaginationState(createPaginationState(state.PageState.PageIndex, size), state.Table))), new PageState(state.PageState.PageIndex, size), state.QueryFn, true), Cmd_ofSub(partialApply(1, state.QueryFn, [[state.PageState.PageIndex, size]]))];
        }
        case 2: {
            return [new State(Table_setData(msg.fields[0], state.Table), state.PageState, state.QueryFn, false), Cmd_none()];
        }
        default: {
            const change = msg.fields[0];
            let pageIndex;
            if (change.tag === 1) {
                pageIndex = (state.PageState.PageIndex - 1);
            }
            else if (change.tag === 2) {
                pageIndex = (state.PageState.PageIndex + 1);
            }
            else if (change.tag === 3) {
                pageIndex = ((~(~(totalItems / state.PageState.PageSize))) - 1);
            }
            else if (change.tag === 4) {
                if ((i = (change.fields[0] | 0), (i > 0) && (i <= (~(~(totalItems / state.PageState.PageSize)))))) {
                    pageIndex = (change.fields[0] - 1);
                }
                else if (change.tag === 4) {
                    pageIndex = state.PageState.PageIndex;
                }
                else {
                    throw (new Error("Match failure"));
                }
            }
            else {
                pageIndex = 0;
            }
            return [new State(Table_setData([], Table_setPaginationState(createPaginationState(pageIndex, state.PageState.PageSize), state.Table)), new PageState(pageIndex, state.PageState.PageSize), state.QueryFn, true), Cmd_ofSub(partialApply(1, state.QueryFn, [[pageIndex, state.PageState.PageSize]]))];
        }
    }
}

export function view(state, dispatch) {
    let elems_7, elems_9;
    let thead;
    const children = toList(delay(() => map((headerGroup) => {
        let elems_1;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_1 = toList(delay(() => map((header) => {
            let elems;
            return createElement("th", createObj(ofArray([["key", header.id], (elems = [Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let tbody;
    const children_4 = toList(delay(() => map((row) => {
        let elems_2;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_2 = toList(delay(() => map((cell) => {
            const children_2 = singleton_2(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
            return createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            });
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    let tfoot;
    const children_6 = toList(delay(() => map((footerGroup) => {
        let elems_4;
        return createElement("tr", createObj(ofArray([["key", footerGroup.id], (elems_4 = toList(delay(() => map((footer) => {
            let elems_3;
            return createElement("th", createObj(ofArray([["key", footer.id], (elems_3 = [Html_flexRender_Z6DEE00B4(footer.column.columnDef.footer, Table_getContext_315F98D7(footer))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
        }, footerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
    }, Table_getFooterGroups_Z4395D14A(state.Table))));
    tfoot = createElement("tfoot", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    });
    let paginationControls;
    const selectOptions = ofList(toList(delay(() => map((i) => [int32ToString(i), [`Show ${i}`, () => {
        dispatch(new Msg(1, i));
    }]], rangeDouble(10, 10, 50)))));
    const pageControl = (text, isDisabled, onClick) => createElement("button", {
        className: join(" ", ["button"]),
        children: text,
        disabled: isDisabled,
        onClick: onClick,
    });
    paginationControls = createElement("div", createObj(ofArray([["className", join(" ", ["is-inline-block"])], (elems_7 = toList(delay(() => append(singleton_1(pageControl("\u003c\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg2) => {
        dispatch(new Msg(0, new PaginateChange(0)));
    })), delay(() => append(singleton_1(pageControl("\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg3) => {
        dispatch(new Msg(0, new PaginateChange(1)));
    })), delay(() => append(singleton_1(pageControl("\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg4) => {
        dispatch(new Msg(0, new PaginateChange(2)));
    })), delay(() => append(singleton_1(pageControl("\u003e\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg5) => {
        dispatch(new Msg(0, new PaginateChange(3)));
    })), delay(() => {
        let children_8;
        return append(singleton_1((children_8 = ofArray(["Page ", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1, " of ", Table_getPageCount_Z4395D14A(state.Table), " | Go to page:"]), createElement("p", {
            children: Interop_reactApi.Children.toArray(Array.from(children_8)),
        }))), delay(() => {
            let properties_6;
            return append(singleton_1(createElement("input", createObj(ofArray([["className", join(" ", ["input"])], ["type", "number"], (properties_6 = singleton_2(["width", 4 + "rem"]), ["style", createObj(properties_6)]), ["defaultValue", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1], ["onChange", (ev) => {
                const value_40 = ev.target.valueAsNumber;
                if ((!(value_40 == null)) && (!Number.isNaN(value_40))) {
                    dispatch(new Msg(0, new PaginateChange(4, round(value_40))));
                }
            }]])))), delay(() => {
                let elems_6, elems_5;
                return append(singleton_1(createElement("div", createObj(ofArray([["className", join(" ", ["select"])], (elems_6 = [createElement("select", createObj(ofArray([["onChange", (event) => {
                    FSharpMap__get_Item(selectOptions, event.target.value)[1]();
                }], ["value", `${Table_getState_Z4395D14A(state.Table).pagination.pageSize}`], (elems_5 = toList(delay(() => map((option) => createElement("option", {
                    key: option[0],
                    value: option[0],
                    children: option[1][0],
                }), selectOptions))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => (state.IsLoading ? singleton_1("Loading...") : singleton_1(null))));
            }));
        }));
    })))))))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])));
    return createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_9 = [createElement("table", {
        children: Interop_reactApi.Children.toArray([thead, tbody, tfoot]),
    }), paginationControls], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=PaginationControlled.fs.js.map
